import React from 'react';
import Animated from 'react-native-reanimated';
import { withTheme, Text } from '@rneui/themed';
import { PositionType, PositionTimeUnit, PlaybackEventEmitter, PlaybackEvent, } from '@annunciate/core';
import { Row, View } from '../elements';
import { ProgressBar, PlayButton, JumpButton, ButtonBar, PlayerImage, ChapterList, ChapterSkipButton, PlayerHandle, TopButtonBar, } from './';
import { useAnimatedUtilityStyles } from '../../hooks/player';
import { TextTicker } from '../shared';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
export const contentToAudioTrack = (content, streamUrl = '') => {
    let artist = '';
    if (content.contributions) {
        artist = content.contributions
            .map((contrib) => contrib.contributor.name)
            .slice(0, 2)
            .join(', ');
    }
    return ({
        id: content.id,
        url: streamUrl,
        title: content.name,
        artist,
        artwork: content.cover?.src,
    });
};
export const UnthemedFullPlayer = ({ playing, position, progressBar, onTogglePlayer, contentContainerStyle, innerContainerStyle, handleContainerStyle, seekBarContainerStyle, playerBarStyle, audioButtonContainerStyle, }) => {
    const track = contentToAudioTrack(playing);
    const { bodyHideStyle } = useAnimatedUtilityStyles(position);
    const isChaptered = playing.chapters && playing.chapters.length > 0;
    const { bottom } = useSafeAreaInsets();
    return (React.createElement(Animated.View, { style: [
            bodyHideStyle,
            contentContainerStyle,
            {
                height: "100%",
                paddingBottom: bottom,
            },
        ] },
        React.createElement(View, { style: handleContainerStyle },
            React.createElement(View, null,
                React.createElement(PlayerHandle, { position: position, onTogglePlayer: onTogglePlayer })),
            React.createElement(View, null,
                React.createElement(TopButtonBar, { containerStyle: playerBarStyle, content: playing }))),
        React.createElement(Animated.View, { style: innerContainerStyle },
            track.artwork && (React.createElement(PlayerImage, { track: track, description: playing.description })),
            React.createElement(View, { style: {
                    paddingVertical: 10,
                    alignItems: 'center',
                    justifyContent: 'center'
                } }, isChaptered ? (React.createElement(ChapterList, { chapters: playing.chapters, onPressChapter: (location) => {
                    const to = {
                        type: PositionType.TIME,
                        unit: PositionTimeUnit.SECONDS,
                        value: location,
                    };
                    PlaybackEventEmitter.emit(PlaybackEvent.SCRUB, { content: playing, to });
                } })) : (React.createElement(React.Fragment, null,
                React.createElement(TextTicker, { bold: true }, track?.title || ''),
                track?.artist ? (React.createElement(Text, { numberOfLines: 1, style: { marginTop: 2 } }, track?.artist || '')) : null))),
            React.createElement(View, { style: seekBarContainerStyle }, progressBar ? progressBar : React.createElement(ProgressBar, { chapters: playing.chapters })),
            React.createElement(Row, { style: audioButtonContainerStyle },
                isChaptered ? (React.createElement(ChapterSkipButton, { direction: 'back', chapters: playing.chapters })) : null,
                React.createElement(JumpButton, { direction: 'back' }),
                React.createElement(PlayButton, { size: "lg", containerStyle: { marginHorizontal: 15 } }),
                React.createElement(JumpButton, { direction: 'forward' }),
                isChaptered ? (React.createElement(ChapterSkipButton, { direction: 'forward', chapters: playing.chapters })) : null),
            React.createElement(ButtonBar, { containerStyle: playerBarStyle, content: playing }))));
};
export const FullPlayer = withTheme(UnthemedFullPlayer, 'FullPlayer');
//# sourceMappingURL=FullPlayer.js.map